import { IResolvedBid } from "@krea/customer-features/types/lenderResponse";
import {
  CustomerPreferredRateEnum,
  RATE_TO_BID_KEY_MAP,
} from "@krea/customer-features/types/loanApplication";

export const getGoodAlternativeLenderResponseIDs = (
  allBids: IResolvedBid[],
  customerPreferredRate: CustomerPreferredRateEnum,
  selectedLenderResponseID?: string,
  recommendedLenderResponseID?: string,
) => {
  if (allBids.length === 0) return [];

  // Don't return a good alternatives list if there is no recommended bid
  if (!recommendedLenderResponseID) return [];

  const finalList: IResolvedBid[] = [];

  // Filter out the bids with attractiveness score of 5 and above and the selected bid
  const filteredBids = allBids.filter(
    (bid) =>
      bid.lenderResponse.attractivenessScore &&
      bid.lenderResponse.attractivenessScore >= 5 &&
      bid.lenderResponse.id !== selectedLenderResponseID,
  );

  if (filteredBids.length > 3) {
    const attractivenessScores = filteredBids
      .sort(
        (a, b) =>
          (b.lenderResponse.attractivenessScore ?? 0) -
          (a.lenderResponse.attractivenessScore ?? 0),
      )
      .map((bid) => bid.lenderResponse.attractivenessScore);

    const bestAttractivenessScores = Array.from(
      new Set(attractivenessScores),
    ).slice(0, 3);

    for (const score of bestAttractivenessScores) {
      // Check how many times it repeats
      const count = attractivenessScores.filter((s) => s === score).length;

      // Filter out the top 3 bids
      // If there are more than 3 bids with the same attractiveness score, sort by effective interest rate
      if (count <= 3) {
        filteredBids.forEach((bid) => {
          if (bid.lenderResponse.attractivenessScore === score) {
            finalList.push(bid);
          }
        });
      } else {
        const rateKey = RATE_TO_BID_KEY_MAP[customerPreferredRate];
        const ratedByEffectiveInterestRate = filteredBids.sort((a, b) => {
          return a[rateKey] - b[rateKey];
        });

        ratedByEffectiveInterestRate.forEach((bid) => {
          if (finalList.length < 3) {
            finalList.push(bid);
          }
        });
      }

      if (finalList.length === 3) {
        break;
      }
    }

    // Return the lenderResponse IDs of the top 3 bids
    return finalList.map((bid) => bid.lenderResponse.id);
  } else {
    return filteredBids.map((bid) => bid.lenderResponse.id);
  }
};
